import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import Hero from '../components/Hero';
import Features from '../components/Features';
import './HomePage.css';

const HomePage = () => {
  const { addToCart } = useCart();

  // Sample featured books data
  const featuredBooks = [
    { id: 1, title: 'كتاب الأدب العربي', author: 'أحمد محمد', price: 150, image: '/api/placeholder/200/250', category: 'أدب' },
    { id: 2, title: 'تاريخ الحضارة الإسلامية', author: 'فاطمة علي', price: 200, image: '/api/placeholder/200/250', category: 'تاريخ' },
    { id: 3, title: 'فن الكتابة الإبداعية', author: 'محمد سالم', price: 180, image: '/api/placeholder/200/250', category: 'فنون' }
  ];

  // Sample interviews data
  const latestInterviews = [
    { id: 1, title: 'لقاء مع الكاتب أحمد محمد', type: 'فيديو', date: '2024-01-15' },
    { id: 2, title: 'حوار حول الأدب المعاصر', type: 'بودكاست', date: '2024-01-20' }
  ];

  // Sample testimonials
  const testimonials = [
    { name: 'سارة أحمد', role: 'كاتبة', text: 'بفضل بصمة آثر تمكنت من نشر روايتي الأولى وحققت حلمي', image: '/api/placeholder/80/80' },
    { name: 'محمد علي', role: 'شاعر', text: 'الدعم والتوجيه الذي حصلت عليه كان نقطة تحول في مسيرتي الأدبية', image: '/api/placeholder/80/80' }
  ];

  return (
    <div className="home-page">
      <Hero />
      <Features />
      
      {/* Statistics Section */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">150+</div>
              <div className="stat-label">كتاب منشور</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">300+</div>
              <div className="stat-label">كاتب مدعوم</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">50+</div>
              <div className="stat-label">مقابلة منجزة</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">5+</div>
              <div className="stat-label">سنوات خبرة</div>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Books Section */}
      <section className="featured-books">
        <div className="container">
          <div className="section-header">
            <h2>الكتب المميزة</h2>
            <p>اكتشف أحدث إصداراتنا من الكتب المتميزة</p>
          </div>
          <div className="books-grid">
            {featuredBooks.map(book => (
              <div key={book.id} className="book-card">
                <div className="book-image">
                  <img src={book.image} alt={book.title} />
                </div>
                <div className="book-info">
                  <h3>{book.title}</h3>
                  <p className="book-author">{book.author}</p>
                  <p className="book-category">{book.category}</p>
                  <div className="book-footer">
                    <span className="book-price">{book.price} جنيه</span>
                    <button 
                      className="btn btn-primary btn-sm"
                      onClick={() => addToCart(book)}
                    >
                      إضافة للسلة
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="section-footer">
            <Link to="/books" className="btn btn-secondary">عرض جميع الكتب</Link>
          </div>
        </div>
      </section>

      {/* Latest Interviews Section */}
      <section className="latest-interviews">
        <div className="container">
          <div className="section-header">
            <h2>آخر المقابلات</h2>
            <p>تابع أحدث المقابلات والحوارات مع كتابنا وفنانينا</p>
          </div>
          <div className="interviews-grid">
            {latestInterviews.map(interview => (
              <div key={interview.id} className="interview-card">
                <div className="interview-type">
                  <span className={`type-badge ${interview.type}`}>
                    {interview.type === 'فيديو' ? '🎥' : '🎙️'} {interview.type}
                  </span>
                </div>
                <h3>{interview.title}</h3>
                <p className="interview-date">{interview.date}</p>
                <Link to="/interviews" className="btn btn-outline">مشاهدة المقابلة</Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials">
        <div className="container">
          <div className="section-header">
            <h2>قصص النجاح</h2>
            <p>اقرأ شهادات من كتابنا الذين حققوا أحلامهم معنا</p>
          </div>
          <div className="testimonials-grid">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="testimonial-card">
                <div className="testimonial-content">
                  <p>"{testimonial.text}"</p>
                </div>
                <div className="testimonial-author">
                  <img src={testimonial.image} alt={testimonial.name} />
                  <div>
                    <h4>{testimonial.name}</h4>
                    <span>{testimonial.role}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Quick Preview Sections */}
      <section className="preview-sections">
        <div className="container">
          <div className="preview-grid">
            <div className="preview-card">
              <div className="preview-icon">
                <i className="fas fa-book"></i>
              </div>
              <h3>مكتبة الكتب</h3>
              <p>اكتشف مجموعة واسعة من الكتب والإصدارات الجديدة من كتابنا الموهوبين</p>
              <Link to="/books" className="btn btn-primary">تصفح الكتب</Link>
            </div>
            
            <div className="preview-card">
              <div className="preview-icon">
                <i className="fas fa-palette"></i>
              </div>
              <h3>معرض الأعمال</h3>
              <p>استمتع بمشاهدة أجمل الأعمال الفنية من رسامينا المبدعين</p>
              <Link to="/gallery" className="btn btn-primary">زيارة المعرض</Link>
            </div>
            
            <div className="preview-card">
              <div className="preview-icon">
                <i className="fas fa-microphone"></i>
              </div>
              <h3>حوارات صحفية</h3>
              <p>اقرأ واستمع لحوارات شيقة مع كتابنا وفنانينا</p>
              <Link to="/interviews" className="btn btn-primary">قراءة الحوارات</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="newsletter">
        <div className="container">
          <div className="newsletter-content">
            <h2>اشترك في نشرتنا الإخبارية</h2>
            <p>احصل على آخر الأخبار والعروض الحصرية مباشرة في بريدك الإلكتروني</p>
            <div className="newsletter-form">
              <input type="email" placeholder="أدخل بريدك الإلكتروني" />
              <button className="btn btn-primary">اشتراك</button>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>هل أنت مستعد لتكون جزءاً من عائلتنا؟</h2>
            <p>انضم إلينا اليوم وابدأ رحلتك نحو تحقيق حلمك الأدبي والفني</p>
            <Link to="/contact" className="btn btn-secondary">انضم إلينا الآن</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
